import axios from "../../axios.js";
const fetchNews = ({ commit }) => {
  const url = `api/news`;
  axios
    .get(url)
    .then((response) => {
      commit("SET_NEWS", response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};
const deleteNews = ({ commit }, id) => {
  const url = `api/news/${id}`;
  axios
    .delete(url)
    .then((response) => {
      commit("SET_BLANK", null);
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
const editNews = ({ commit }, body) => {
  const url = `api/news/${body.id}`;
  axios
    .put(url, body.obj)
    .then((response) => {
      commit("SET_BLANK", null);
      return response.data;
    })
    .catch((err) => {
      console.log(err.response);
    });
};
const addNews = ({ commit }, body) => {
  const url = `api/news`;
  axios
    .post(url, body)
    .then((response) => {
      console.log(response);
      commit("SET_BLANK", null);
      return response.data;
    })
    .catch((err) => {
      console.log(err.response);
    });
};

export default {
  fetchNews,
  deleteNews,
  addNews,
  editNews,
};
